import { defineMessages } from 'react-intl';

export default defineMessages({
  gasTitle: {
    id: 'app.containers.PropertyAssessment.v2.gasTitle',
    defaultMessage: 'Gás',
  },
  gasDescription: {
    id: 'app.containers.PropertyAssessment.v2.gasDescription',
    defaultMessage:
      'Nesta etapa você vai avaliar a instalação do serviço de gás e aquecedor',
  },
  gasSupplyTitle: {
    id: 'app.containers.PropertyAssessment.v2.gasSupplyTitle',
    defaultMessage: 'Abastecimento de gás',
  },
  gasRegisterTitle: {
    id: 'app.containers.PropertyAssessment.v2.gasRegisterTitle',
    defaultMessage: 'Registro de gás',
  },
  waterHeaterTitle: {
    id: 'app.containers.PropertyAssessment.v2.waterHeaterTitle',
    defaultMessage: 'Aquecedor de água',
  },

  gasSupplyTypeQuestion: {
    id: 'app.containers.PropertyAssessment.v2.gasSupplyTypeQuestion',
    defaultMessage: 'Qual é o tipo do abastecimento de gás?',
  },
  gasRegisterLocationQuestion: {
    id: 'app.containers.PropertyAssessment.v2.gasRegisterLocationQuestion',
    defaultMessage: 'O registro de gás está dentro do imóvel?',
  },
  gasRegisterNearWindowsDoorsQuestion: {
    id: 'app.containers.PropertyAssessment.v2.gasRegisterNearWindowsDoorsQuestion',
    defaultMessage: 'Há janelas e portas no ambiente?',
  },
  gasRegisterNearElectricalInstallationsQuestion: {
    id: 'app.containers.PropertyAssessment.v2.gasRegisterNearElectricalInstallationsQuestion',
    defaultMessage:
      'Tem alguma instalação elétrica próxima ao registro de gás?',
  },
  gasPipeColorQuestion: {
    id: 'app.containers.PropertyAssessment.v2.gasPipeColorQuestion',
    defaultMessage: 'Qual a cor das tubulações?',
  },
  gasPipeIsLabeledQuestion: {
    id: 'app.containers.PropertyAssessment.v2.gasPipeIsLabeledQuestion',
    defaultMessage: 'Há identificação da palavra "GÁS" nas tubulações?',
  },
  gasRegisterInEnclosedSpaceQuestion: {
    id: 'app.containers.PropertyAssessment.v2.gasRegisterInEnclosedSpaceQuestion',
    defaultMessage: 'O registro está instalado dentro de um local fechado?',
  },
  gasRegisterInEnclosedSpaceDescription: {
    id: 'app.containers.PropertyAssessment.v2.gasRegisterInEnclosedSpaceDescription',
    defaultMessage: 'Exemplo: armário embutido',
  },
  gasRegisterConservationQuestion: {
    id: 'app.containers.PropertyAssessment.v2.gasRegisterConservationQuestion',
    defaultMessage:
      'Que opção representa melhor a conservação do registro de gás?',
  },
  waterHeaterInstalledQuestion: {
    id: 'app.containers.PropertyAssessment.v2.waterHeaterInstalledQuestion',
    defaultMessage: 'O imóvel tem aquecedor instalado?',
  },
  waterHeaterLocationQuestion: {
    id: 'app.containers.PropertyAssessment.v2.waterHeaterLocationQuestion',
    defaultMessage: 'Em qual cômodo o aquecedor está instalado?',
  },
  waterHeaterNearWindowsDoorsQuestion: {
    id: 'app.containers.PropertyAssessment.v2.waterHeaterNearWindowsDoorsQuestion',
    defaultMessage: 'O aquecedor está próximo de janelas e/ou o portas?',
  },
  waterHeaterConservationQuestion: {
    id: 'app.containers.PropertyAssessment.v2.waterHeaterConservationQuestion',
    defaultMessage: 'Que opção representa melhor a conservação do aquecedor?',
  },
  commentQuestion: {
    id: 'app.containers.PropertyAssessment.v2.commentQuestion',
    defaultMessage: 'Conte quais são os outros cômodos:',
  },
  commentDescription: {
    id: 'app.containers.PropertyAssessment.v2.commentDescription',
    defaultMessage: 'Separe os cômodos com vírgulas',
  },

  pipedGas: {
    id: 'app.containers.PropertyAssessment.v2.pipedGas',
    defaultMessage: 'Gás encanado',
  },
  gasCanister: {
    id: 'app.containers.PropertyAssessment.v2.gasCanister',
    defaultMessage: 'Botijão',
  },
  gasPipeColorYellow: {
    id: 'app.containers.PropertyAssessment.v2.gasPipeColorYellow',
    defaultMessage: 'Amarelo',
  },
  gasPipeColorAluminum: {
    id: 'app.containers.PropertyAssessment.v2.gasPipeColorAluminum',
    defaultMessage: 'Alumínio',
  },

  kitchen: {
    id: 'app.containers.PropertyAssessment.v2.kitchen',
    defaultMessage: 'Cozinha',
  },
  bathroom: {
    id: 'app.containers.PropertyAssessment.v2.bathroom',
    defaultMessage: 'Banheiro',
  },
  serviceArea: {
    id: 'app.containers.PropertyAssessment.v2.serviceArea',
    defaultMessage: 'Área de serviço',
  },

  needsRepair: {
    id: 'app.containers.PropertyAssessment.v2.needsRepair',
    defaultMessage: 'Precisa de troca ou reparo imediato',
  },
  manySignsOfUse: {
    id: 'app.containers.PropertyAssessment.v2.manySignsOfUse',
    defaultMessage: 'Com muitas marcas de uso',
  },
  fewSignsOfUse: {
    id: 'app.containers.PropertyAssessment.v2.fewSignsOfUse',
    defaultMessage: 'Com leves marcas de uso',
  },
  newItem: {
    id: 'app.containers.PropertyAssessment.v2.newItem',
    defaultMessage: 'Novo, sem marcas de uso',
  },

  yes: {
    id: 'app.containers.PropertyAssessment.v2.yes',
    defaultMessage: 'Sim',
  },
  no: {
    id: 'app.containers.PropertyAssessment.v2.no',
    defaultMessage: 'Não',
  },
  other: {
    id: 'app.containers.PropertyAssessment.v2.other',
    defaultMessage: 'Outro',
  },
  doesNotHave: {
    id: 'app.containers.PropertyAssessment.v2.doesNotHave',
    defaultMessage: 'Não possui',
  },
});
